var echoHandOffData = {};
export var updateEchoHandoffData = function (data) {
    echoHandOffData = data || {};
};
export var getEchoHandoffData = function () { return echoHandOffData || {}; };
//# sourceMappingURL=helpers.js.map